export default "__VITE_ASSET__BVY8ly3g__"